import Form from "@/components/common/form/form";
import Model from "@/components/common/model.component";
import PageTitle from "components/common/page-title.component";
import { useTranslation } from "react-i18next";
import { useSwrGet } from "@/utils/use-swr-get";
import { useRouter } from "next/router";
import Select from "@/components/common/form/select";
import Button from "components/common/form/button";
import { useDispatch } from "react-redux";

import {
  setFarmData,
  setFarmFormStep,
  setCurrentType,
} from "@/redux/actions/farms";
import { navigationServices } from "services/navigation.service";

function SubmitButton({ t, passProps, ...props }) {
  return (
    <Button
      title={t("Save & Continue")}
      className="w-full h-[35px] text-white rounded-lg bg-main  text-md mt-5"
      loading={props.props?.formState?.isSubmitting}
    />
  );
}
type PropsType = { label: any; showModel?: any; setShowModel?: any };
const TreeModal: React.FC<PropsType> = ({ label, showModel, setShowModel }) => {
  const router = useRouter();
  const dispatch = useDispatch();

  const {
    data: farmsData,
    isLoading: farmIsLoading,
    isError: farmIsError,
  } = useSwrGet(`/farmddd/all`, process.env.NEXT_PUBLIC_BASE_URL + `farms/`);

  const onSubmit = async (data, e) => {
    data.farm_id = Number(data.farm_id);
    let id;
    dispatch(
      setFarmData({
        key: "farm",
        farm: { id: data.farm_id },
      })
    );

    router.push(`/farms/new`);
  };
  const { t } = useTranslation();
  return (
    <Model
      show={showModel}
      width="w-100"
      onClose={(e) => {
        setShowModel(false);
      }}
    >
      <PageTitle
        title={t(t("Add") + " " + label + " " + t("on Map"))}
        titletextSize="text-xl"
      />

      <div className="my-5">
        <Form onSubmit={onSubmit}>
          <Select
            name="farm_id"
            label="Farm"
            options={farmsData?.results?.map?.((item) => ({
              label: item.farm_name,
              value: item.id,
            }))}
            onChange={async (e) => {
              let selectedFarm = await farmsData?.results?.find?.(
                (ffarm) => Number(ffarm.id) === Number(e.target.value)
              );

              let farmType = farmsData?.results?.find?.(
                (ffarm) => Number(ffarm.id) === Number(e.target.value)
              ).farming_type;

              let res = await navigationServices.getGboundry(
                selectedFarm.gboundary_id
              );

              if (res) {
                dispatch(setCurrentType(farmType));
                dispatch(setFarmFormStep(5));
                dispatch(
                  setFarmData({
                    key: "farm",
                    value: { ...selectedFarm },
                  })
                );

                dispatch(
                  setFarmData({
                    key: "geo_farm",
                    value: { ...res.data },
                  })
                );
              }
            }}
          />
          <SubmitButton passProps t={t}></SubmitButton>
        </Form>
      </div>
    </Model>
  );
};

export default TreeModal;
